// extracted by mini-css-extract-plugin
module.exports = {"HOME":"Home_HOME__2hFFS"};